import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amount'
})
export class AmountPipe implements PipeTransform {

  transform(value: string, params?: { amount: string | number }): string {
    if (!value || !params) return value;

    return value.replace('{amount}', String(params.amount));
  }
  
}
